/**
 * 確認画面フォームの二重送信防止
 *
 * 送信完了までに数秒かかる間に「送信する」をもう一度押されると、完了処理が
 * 並行して走り、申し込みが2件登録されてメールも2通届いてしまう。
 * サーバ側にもガードを入れてあるが、無駄なリクエスト自体を投げさせない。
 */
const main = () => {
    document.querySelectorAll(".js-confirm-form").forEach((form) => {
        let isSubmitting = false;

        form.addEventListener("submit", (event) => {
            if (isSubmitting) {
                event.preventDefault();

                return;
            }

            isSubmitting = true;

            // この場で disabled にすると送信値の組み立てから除外され、
            // 「修正する」の name="back" がサーバへ送られなくなる。
            // 組み立てが終わる次のタスクまで遅らせる
            setTimeout(() => {
                form.querySelectorAll("button[type='submit']").forEach((button) => {
                    button.disabled = true;
                });
            }, 0);
        });
    });
};

export default main;
